// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_boulder: PokeData = {
  "id": 1022,
  "name": "iron-boulder",
  "height": 15,
  "weight": 1625,
  "base_experience": 295,
  "types": [
    PokeType.ROCK,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "swords-dance",
    "horn-attack",
    "leer",
    "counter",
    "rock-throw",
    "agility",
    "quick-attack",
    "slash",
    "megahorn",
    "rock-tomb",
    "giga-impact",
    "psycho-cut",
    "stone-edge",
    "quick-guard",
    "sacred-sword",
    "electric-terrain",
    "mighty-cleave"
  ],
  "moves": [
    "leer",
    "rock-throw",
    "quick-attack",
    "rock-tomb",
    "electric-terrain",
    "ancient-power",
    "psychic-terrain",
    "zen-headbutt",
    "seismic-toss",
    "kinesis",
    "psy-ball",
    "synchronize",
    "rock-blast"
  ],
  "evolution_chain": {
    "id": 547,
    "item": null,
    "species": [
      {
        "name": "iron-boulder",
        "order": 1024,
        "types": [
          PokeType.ROCK,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 148,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
